export default [
  {
    name: "home",
    meta: {
      title: "Home",
      sort: 0,
      authenticatable: true,
      description: "View app overview and summary",
      icon: "mdi-home-outline",
      permission: false,
    },
  },

  // {
  //   name: 'divider:dashboard/index',
  //   meta: {
  //     title: 'Content',
  //     sort: 1,
  //     subheader: true,
  //     height: 2,
  //   },
  // },
];
